import React from 'react';

export default function joinElements(elements, separator) {
  return elements.reduce((all, element, index, _elements) => {
    all.push(React.cloneElement(element, { key: index * 2 }));
    if (index !== _elements.length - 1) {
      all.push(React.cloneElement(separator, { key: index * 2 + 1 }));
    }

    return all;
  }, []);
}
